// src/pages/OperatingHoursPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faGoogle } from '@fortawesome/free-brands-svg-icons';
import Footer from '../components/Footer';
import '../styles/OperatingHoursPage.css';

const OperatingHoursPage = () => (
  <div className="hours-page">

    <header className="hours-page__header">
      <span className="hours-page__eyebrow">Plan Your Visit</span>
      <h1 className="hours-page__title">Operating Hours</h1>
      <hr className="gold-divider gold-divider--center" />
    </header>

    <div className="hours-page__inner">

      {/* Main hours cards */}
      <div className="hours-cards">
        <div className="hours-card">
          <span className="hours-card__icon" aria-hidden="true">🗓️</span>
          <h2>Monday – Sunday</h2>
          <p>11:30 AM – 3:00 PM<br />5:30 PM – 11:00 PM</p>
        </div>
        <div className="hours-card">
          <span className="hours-card__icon" aria-hidden="true">🍽️</span>
          <h2>Last Orders</h2>
          <p>10:00 PM</p>
          <p className="hours-card__note">Kitchen closes at 10 PM daily</p>
        </div>
      </div>

      {/* Holiday notice */}
      <div className="hours-holiday">
        <span className="hours-holiday__icon" aria-hidden="true">📢</span>
        <div>
          <h2>Public Holiday Hours</h2>
          <p>
            Hours may vary on public holidays and special events.
            Follow us on social media for the latest updates.
          </p>
        </div>
      </div>

      {/* Social */}
      <div className="hours-social">
        <p>Follow Us for Updates</p>
        <div className="hours-social__icons">
          <a href="https://www.facebook.com/profile.php?id=61556215584916" className="hours-social__icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://www.instagram.com/lebua_thai/" className="hours-social__icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://g.co/kgs/Ct72hTQ" className="hours-social__icon" target="_blank" rel="noopener noreferrer" aria-label="Google">
            <FontAwesomeIcon icon={faGoogle} />
          </a>
        </div>
      </div>

    </div>{/* hours-page__inner */}
    <Footer />
  </div>
);

export default OperatingHoursPage;
